import { render, staticRenderFns } from "./ApplianceModelsList.vue?vue&type=template&id=cbf162d6"
import script from "./ApplianceModelsList.vue?vue&type=script&lang=js"
export * from "./ApplianceModelsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports